<app-add-form
  [title]="updatedFormConfig().title"
  [formFields]="updatedFormConfig().formFields"
  [headerActions]="updatedFormConfig().headerActions"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [initialData]="combinedInitialData()"
  [loading]="loading()"
  (formAction)="onFormAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
  (fileChanged)="onLogoFileChange($event)"
>
</app-add-form>

<p-toast></p-toast>
